import getConfig from 'next/config';
import { VisitorHeaderDataProvider, VisitorSEOHeader } from '@care/navigation';
import { logOrEnqueueEvent } from '@/lib/analyticsHelper';
import { getFindCareMenuContent } from '@/helpers/navigationMenuContent/getFindCareMenuContent';
import { seoSegmentationListingPage } from '@/__generated__/seoSegmentationListingPage';
import { getFindJobsMenuContent } from '@/helpers/navigationMenuContent/getFindJobsMenuContent';
import { narrowSeoNavigationLinkSection } from '@/helpers/narrowSeoNavigationLinkSection';
import { useResponsive } from '../hooks/useResponsive';

const {
  publicRuntimeConfig: { NEXT_PUBLIC_APP_URL },
} = getConfig();

interface SeoGlobalNavbarProps {
  seoNavigationLinkSection?: seoSegmentationListingPage['seoNavigationLinkSection'] | null;
}

export const SeoGlobalNavbar = ({ seoNavigationLinkSection = null }: SeoGlobalNavbarProps) => {
  const { isLargeViewport } = useResponsive();

  const navLinkSection = narrowSeoNavigationLinkSection(seoNavigationLinkSection);
  const navMenuContent = navLinkSection ? navLinkSection.seoNavigationLinkSection : null;

  const findCareMenuLinks = navMenuContent
    ? getFindCareMenuContent(NEXT_PUBLIC_APP_URL, navMenuContent, isLargeViewport)
    : undefined;

  const findJobsMenuLinks = navMenuContent
    ? getFindJobsMenuContent(NEXT_PUBLIC_APP_URL, navMenuContent)
    : undefined;

  return (
    <VisitorHeaderDataProvider
      baseUrl={NEXT_PUBLIC_APP_URL}
      logAnalyticsEvent={logOrEnqueueEvent}
      findCareMenuLinks={findCareMenuLinks ?? undefined}
      findJobsMenuLinks={findJobsMenuLinks ?? undefined}>
      <VisitorSEOHeader />
    </VisitorHeaderDataProvider>
  );
};
